// @flow
import * as React from 'react';
import {Check, Close} from "@mui/icons-material";
import moment from "moment";
import {Link} from "react-router-dom";
import { Box, ButtonBase, Typography } from '@mui/material';
import {useRoundRobinTaskHistoryDrawer, withRoundRobinTaskHistoryDrawer} from "./round-robin-task-history-drawer";
import {
  DataGrid,
  DataGridColumn,
  useAgentCallAgenda, useSessionStorageState
} from '../../../shared';
import {
  AgentCallAgendaTaskHistoryItemOutput,
  AgentCallAgendaTaskOutput, PageInput
} from '@coverright/data-access/types/enrollment';
import { getRoute } from '../../../app/router';
import { useState } from 'react';
import _ from 'lodash';
import { SearchInput } from '@coverright/ui/inputs';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';


export function RoundRobinTasksF() {
  const {state: data} = useAgentCallAgenda()
  const [{ page, size }, setPage] = usePage();
  const [term, setTerm] = useState('');
  const tasks = data?.tasks || [];
  const filtered = term ? tasks.filter(t => t.clientName.toLowerCase().includes(term.toLowerCase()) || t.clientEmail.toLowerCase().includes(term.toLowerCase())) : tasks;

  const {open: openHistory} = useRoundRobinTaskHistoryDrawer();

  const pageTasks = _.chunk(_.orderBy(filtered, 'createdAt', 'desc'), size)[page] || [];

  return (
    <>
      <Box mb={1} width={1} maxWidth={500}>
        <SearchInput InputProps={{
          startAdornment: <MagnifyingGlassIcon size={24} />
        }} value={term} onChange={setTerm} />
      </Box>
      <DataGrid columns={columns(openHistory)}
                page={page}
                total={filtered.length}
                onPageChange={p => setPage(prev => ({...prev, page: p }))}
                onRowsPerPageChange={p => setPage(prev => ({...prev, size: p }))}
                rowsPerPage={20}
                loading={!data}
                rows={pageTasks}/>
    </>
  );
}

export const RoundRobinTasks = withRoundRobinTaskHistoryDrawer(RoundRobinTasksF);

const columns: (openHistory: (rows: AgentCallAgendaTaskHistoryItemOutput[]) => void) => DataGridColumn<AgentCallAgendaTaskOutput, keyof AgentCallAgendaTaskOutput>[] = (openHistory) => [
  {
    title: 'Created At',
    value: v => <Typography>{moment(v.createdAt).format('MM/DD/YY HH:mm:ss')}</Typography>,
  },
  {
    title: 'IsNew',
    value: v => v.isNew ? <Check color={'success'} /> : <Close color={'error'} />
  },
  {
    title: 'Completed',
    value: v => v.completed ? <Check color={'success'} /> : <Close color={'error'} />
  },
  {
    title: 'Client ',
    value: v => (
      <Typography component={Link}
                  color={'textPrimary'}
                  sx={{textDecoration: 'underline'}}
                  to={`/${getRoute('client')}/${v.clientId}`}>
        {v.clientName} ({v.clientEmail})
      </Typography>
    )
  },
  {
    title: '',
    value: v =>  (
      <ButtonBase component={Typography}
                  onClick={() => openHistory(v.assignmentHistory)}
                  sx={{textDecoration: 'underline'}}>
        Show history
      </ButtonBase>
    )
  },

]

const usePage = () => {
  return useSessionStorageState<PageInput>(
    'rrTasksPage',
    { page: 0, size: 20 }
  );
};
